<template>
	<vuescroll ref="vuescroll" :ops="vuescrollOptions" @handle-scroll="handleScroll">
		<div class="content" :style="contentStyle">
			<slot />
		</div>
	</vuescroll>
</template>

<script>
import vuescroll from 'vuescroll'

const options = {
	portal: {
		rail: { size: '20px', background: '#f0f0f1', opacity: 1 },
		bar: { size: '20px', background: '#e10072', keepShow: true }
	},
	events: {
		rail: { size: '5px', background: '#000000', opacity: 0.3 },
		bar: { size: '5px', background: '#c5c4ff', keepShow: true },
		vuescroll: { wheelScrollDuration: 450, scrollingX: false }
	}
}

export default {
	name: 'ScrollWrapper',
	components: { vuescroll },
	props: {
		theme: {
			type: String,
			default: 'events',
			validator: value => ['events', 'portal'].includes(value)
		},
		contentStyle: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		vuescrollOptions () {
			return options[this.theme]
		}
	},
	mounted () {
		this.$watch('$refs.vuescroll.classHooks', this.checkScrollbarExist, { deep: true })
	},
	methods: {
		checkScrollbarExist () {
			const classHooks = this.$refs.vuescroll && this.$refs.vuescroll.classHooks
			const hasScrolledContent = classHooks && (classHooks.hasVBar || classHooks.vBarVisible)

			this.$emit('hasScrolledContent', hasScrolledContent)
		},
		handleScroll (event) {
			this.$emit('onScroll', event)
		},
		refresh () {
			this.$refs.vuescroll.refresh()
		},
		scrollToBottom (speed) {
			this.$refs.vuescroll.scrollTo({ y: '100%' }, speed || 500)
		}
	}
}
</script>
